import {PTGC_SELECT_CARD} from './../../constants';

const pushToGoogleCalendarSelectCard = (cardId) => ({
    type: PTGC_SELECT_CARD,
    cardId
});

export default pushToGoogleCalendarSelectCard;